import React, { Component, useState } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { DateTime } from 'luxon';
import axios from '../../utils/axios';

import Button from '@mui/material/Button';

import withStyles from '@mui/styles/withStyles';

import { setApiResponseInfo } from '../../store/slices/apiResponseInfoSlice';

import { createStdRequest, apiFetch, showAlert, reportTime } from '../../utils/utils';

import version from '../../version';

import Showable from '../../components/Showable';
import AlertModal from '../../components/AlertModal';
import KSelect from '../../components/KSelect';
import Modal from '../../components/Modal';
import CrmTextField from '../../components/CrmTextField';

const homeStyles = {
  root: {
    textAlign: 'center',
    width: '600px',
    backgroundColor: '#eeeeff',
    padding: '6px',
    margin: 'auto',
    '& .pageDescrip': {
      textAlign: 'left',
      paddingLeft: '100px',
    },
  },
  callRailConfigDiv: {
    border: '1px black solid',
    marginBottom: '6px',
    marginLeft: '140px',
    width: '420px',
  },
  config4CrButton: {
    marginRight: '80px',
  },
  salesLineUiDiv: {
    border: '1px black solid',
    marginBottom: '6px',
    marginLeft: '140px',
    width: '420px',
  },
  setSalesLineButton: {
    marginRight: '80px',
  },
};

class SuperAdminHome extends Component {
  constructor(props) {
    super(props);

    this.state = {
      redirect: undefined,
      prefix: 'AutoSeed',
      nDeleted: 0,
      nMatchingDemos: 0,
      continueDeleting: true,
      lostDropdownItems: null,
      shouldShowLostDropdownItems: false,
      justDetectTrimmableStrings: true,
      oldAutoSeedPrefix: 'AutoSeed10x10',
      newAutoSeedPrefix: 'AutoSeed100x10',
      randomDistribution: false,
      shouldShowSalesLineUI: false,
      phoneForAccount: '',
      firmsWithoutSalesLines: [],
      salesLineTargetFirmId: 0,
    };
  }

  showInitDropdownsButton = true;
  showRegularizePhoneNumbersButton = false;
  showStandardizePhoneNumbersButton = false;
  showPromoteNonesButton = false;
  showConvertToSingleFacilityAddressButton = false;
  showPopulateFirmTypeNameButton = false;
  showPartitionReferralSourceTypeDropdownItemsButton = false;
  showCopyFirmTypeNameFieldButton = false;
  showPopulateApiKeyFirmIdFieldsButton = false;
  showPopulateReimbursementDropdownButton = false;
  showPopulateDocTypeDropdownButton = false;
  showDeleteDocumentsButton = false;
  showExtendSexButton = false;
  showCopyToSexButton = false;
  showShowLostDropdownItemsButton = false;
  showRestoreLostDropdownItemsButton = false;
  showRepairNullPhoneRolesButton = false;
  showTrimDbStringsButton = false;
  showRenameAutoSeedsButton = false;
  showEnableDefaultDropdownItemProtectionButton = false;
  showWebhookValidationButton = false;
  showLogTestButton = false;
  showSendGridTestButton = false;
  showTestEnvVarsButton = false;
  showPatchOtherPartyButton = false;
  showSimulateDischargeButton = false;
  showKludgeBirthdatesButton = false;
  showKludgeClientPhoneNumbersButton = false;
  showAddEdConsultDropdownItemButton = false;
  showTestUserRolesTable = false;
  showPatchOwnershipsButton = false;
  showRandomExperimentButton = true;
  showPatchDateTimesButton = false;
  showSetTimeZoneButton = false;
  showPatchVobInfoButton = false;
  showDeleteDupsButton = false;
  showInferReferralSourceTypesButton = true;
  showInferLeadSourceTypesButton = true;
  showMigrateDeletedReferralsButton = true;
  showProcessMissingCallsButton = false;
  showProcessCallsWithNoFirmIdButton = true;
  showExportCleanRecoveryClientNotesButton = true;
  showConvertCallRailMemosButton = true;
  showCopyFirmTypeButton = false;
  showPopulateF2fvEmailButton = false;
  showPopulateAppUserExtTableButton = true;

  timeZoneOptions = ['Eastern', 'Central', 'Mountain', 'Pacific', 'Indiana', 'Arizona'];
  timeZoneValues = [
    'America/New_York',
    'America/Chicago',
    'America/Denver',
    'America/Los_Angeles',
    'America/Indiana/Indianapolis',
    'America/Phoenix',
  ];

  queryForFirmsWithoutSalesLines() {
    // Make API call to determine which firms are not yet configured
    const uri = '/api/superAdmin/firmsWithoutSalesLines';
    const request = createStdRequest(uri);
    const actionOnGoodResponse = (json) => {
      this.setState({ firmsWithoutSalesLines: json });
    };
    apiFetch(this, request, actionOnGoodResponse);
  }

  handleDownloadFirmClick() {
    this.setState({ redirect: 'downloadFirm' });
  }

  handleSalesLineTargetFirmChange(newFirmId) {
    this.setState({
      salesLineTargetFirmId: newFirmId,
      phoneForAccount: '+12063319150',
    });
  }

  handleViewAllAccountsClick() {
    this.setState({ redirect: 'accounts' });
  }

  handleUploadSpreadsheetClick() {
    this.setState({ redirect: 'uploadSpreadsheet' });
  }

  handleViewDemosClick() {
    this.setState({ redirect: 'demos' });
  }

  handleLaunchDemoClick() {
    // redirect to the launcher page
    this.setState({ redirect: 'launchDemo' });
  }

  handleRegisterProviderClick() {
    this.setState({ redirect: 'registerAccount' });
  }

  handleConfigEmrSyncClick() {
    this.setState({ redirect: 'configureEmrSync' });
  }

  handleShowSalesLineUIClick() {
    this.queryForFirmsWithoutSalesLines();
    this.setState({
      shouldShowSalesLineUI: true,
      phoneForAccount: '+12063319150',
    });
  }

  isStdFormatPhoneNumber(numStr) {
    if (numStr.length !== 12 || numStr[0] !== '+') {
      return false;
    }
    for (let i = 1; i < 12; i++) {
      const ch = numStr[i];
      if (ch < '0' || ch > '9') {
        return false;
      }
    }
    return true;
  }

  handleSetSalesLineClick() {
    if (!this.state.salesLineTargetFirmId) {
      alert('You need to select an Account');
      return;
    }

    if (!this.isStdFormatPhoneNumber(this.state.phoneForAccount)) {
      alert('The Phone number must be in format: "+1dddddddddd"');
      return;
    }

    const uri = '/api/superAdmin/setFirmSalesLine';
    const apiStruct = {
      firmId: this.state.salesLineTargetFirmId,
      phoneNumber: this.state.phoneForAccount,
    };
    const request = createStdRequest(uri, 'post', apiStruct);
    const actionOnGoodResponse = () => {
      this.queryForFirmsWithoutSalesLines();
      alert('Success');
    };
    apiFetch(this, request, actionOnGoodResponse);
  }

  initCustomizableDropdowns() {
    const uri = '/api/superAdmin/initCustomizableDropdowns';
    const request = createStdRequest(uri);
    const actionOnGoodResponse = () => {
      showAlert(this, 'Done initializing customizable dropdowns');
    };
    apiFetch(this, request, actionOnGoodResponse);
  }

  regularizePhoneNumbers() {
    const uri = '/api/person/regularizePhoneNumbers';
    const request = createStdRequest(uri);
    const actionOnGoodResponse = () => {
      showAlert(this, 'Done regularizing phone numbers');
    };
    apiFetch(this, request, actionOnGoodResponse);
  }

  standardizePhoneNumbers() {
    const uri = '/api/person/standardizePhoneNumbers';
    const request = createStdRequest(uri);
    const actionOnGoodResponse = () => {
      showAlert(this, 'Done standardizing phone numbers');
    };
    apiFetch(this, request, actionOnGoodResponse);
  }

  convertNonesToProspects() {
    const uri = '/api/client/convertNonesToProspects';
    const request = createStdRequest(uri);
    const actionOnGoodResponse = () => {
      showAlert(this, 'Done converting Nones to Prospects');
    };
    apiFetch(this, request, actionOnGoodResponse);
  }

  convertToSingleFacilityAddressScheme() {
    const uri = '/api/superAdmin/convertToSingleFacilityAddress';
    const request = createStdRequest(uri);
    const actionOnGoodResponse = () => {
      showAlert(this, 'Done converting to Single Facility Address scheme');
    };
    apiFetch(this, request, actionOnGoodResponse);
  }

  populateFirmTypeName() {
    const uri = '/api/superAdmin/populateFirmTypeName';
    const request = createStdRequest(uri);
    const actionOnGoodResponse = () => {
      showAlert(this, 'Done populating FirmTypeName field');
    };
    apiFetch(this, request, actionOnGoodResponse);
  }

  partitionReferralSourceTypeDropdownItems() {
    const uri = '/api/superAdmin/splitReferringOrgTypeDropdown';
    const request = createStdRequest(uri);
    const actionOnGoodResponse = () => {
      showAlert(this, 'Done partitioning referral source type dropdown items');
    };
    apiFetch(this, request, actionOnGoodResponse);
  }

  copyFirmTypeNameField() {
    const uri = '/api/superAdmin/copyFirmTypeNameField';
    const request = createStdRequest(uri);
    const actionOnGoodResponse = () => {
      showAlert(this, 'Done copying FirmTypeName field');
    };
    apiFetch(this, request, actionOnGoodResponse);
  }

  populateApiKeyFirmIdFields() {
    const uri = '/api/superAdmin/populateApiKeyFirmIdFields';
    const request = createStdRequest(uri);
    const actionOnGoodResponse = () => {
      showAlert(this, 'Done populating ApiKey FirmId Fields');
    };
    apiFetch(this, request, actionOnGoodResponse);
  }

  populateReimbursementDropdown() {
    const uri = '/api/superAdmin/populateReimbursementDropdown';
    const request = createStdRequest(uri);
    const actionOnGoodResponse = () => {
      showAlert(this, 'Done repopulating Reimbursement Dropdown');
    };
    apiFetch(this, request, actionOnGoodResponse);
  }

  populateDocTypeDropdown() {
    const uri = '/api/superAdmin/populateDocTypeDropdown';
    const request = createStdRequest(uri);
    const actionOnGoodResponse = () => {
      showAlert(this, 'Done populating DocumentType dropdown');
    };
    apiFetch(this, request, actionOnGoodResponse);
  }

  deleteAllDocuments() {
    const uri = '/api/superAdmin/deleteAllDocuments';
    const request = createStdRequest(uri);
    const actionOnGoodResponse = () => {
      showAlert(this, 'Done deleting documents');
    };
    apiFetch(this, request, actionOnGoodResponse);
  }

  fillInExtendedSex() {
    const uri = '/api/superAdmin/fillInExtendedSex';
    const request = createStdRequest(uri);
    const actionOnGoodResponse = () => {
      showAlert(this, 'Done copying gender to extended fields');
    };
    apiFetch(this, request, actionOnGoodResponse);
  }

  copyToSex() {
    const uri = '/api/superAdmin/copyToSexField';
    const request = createStdRequest(uri);
    const actionOnGoodResponse = () => {
      showAlert(this, 'Done copying gender to correct field');
    };
    apiFetch(this, request, actionOnGoodResponse);
  }

  showLostDropdownItems() {
    const uri = '/api/superAdmin/showLostDropdownItems';
    this.setState({ lostDropdownItems: null, shouldShowLostDropdownItems: false });
    const request = createStdRequest(uri);
    const actionOnGoodResponse = (json) => {
      this.setState({ lostDropdownItems: json, shouldShowLostDropdownItems: true });
    };
    apiFetch(this, request, actionOnGoodResponse);
  }

  restoreLostDropdownItems() {
    const uri = '/api/superAdmin/restoreLostDropdownItems';
    const request = createStdRequest(uri);
    const actionOnGoodResponse = () => {
      showAlert(this, 'Done restoring lost dropdown items');
    };
    apiFetch(this, request, actionOnGoodResponse);
  }

  repairNullPhoneRoles() {
    const uri = '/api/superAdmin/repairNullPhoneRoles';
    const request = createStdRequest(uri);
    const actionOnGoodResponse = () => {
      showAlert(this, 'Done repairing NULL phone roles');
    };
    apiFetch(this, request, actionOnGoodResponse);
  }

  trimDbStrings() {
    const justDetect = this.state.justDetectTrimmableStrings;
    const uri = `/api/superAdmin/detectTrimmableStrings?fix=${!justDetect}`;
    const request = createStdRequest(uri);
    const actionOnGoodResponse = (json) => {
      console.log(json);
      showAlert(this, 'Back from call to detectTrimmableStrings');
    };
    apiFetch(this, request, actionOnGoodResponse);
  }

  renameAutoSeeds() {
    const old = this.state.oldAutoSeedPrefix;
    const noo = this.state.newAutoSeedPrefix;
    const uri = `/api/superAdmin/renameAutoSeeds?oldPrefix=${old}&newPrefix=${noo}`;
    const request = createStdRequest(uri);
    const actionOnGoodResponse = () => {
      showAlert(this, 'Back from call to renameAutoSeeds');
    };
    apiFetch(this, request, actionOnGoodResponse);
  }

  handleDetectTrimmableStringsCheckboxChange(event) {
    this.setState({ justDetectTrimmableStrings: event.target.checked });
  }

  enableDefaultDropdownItemProtection() {
    const uri = '/api/superAdmin/enableDefaultDropdownItemProtection';
    const request = createStdRequest(uri);
    const actionOnGoodResponse = () => {
      showAlert(this, 'Back from call to enableDefaultDropdownItemProtection');
    };
    apiFetch(this, request, actionOnGoodResponse);
  }

  testWebookValidation() {
    const uri = '/api/superAdmin/testWebhookValidation';
    const request = createStdRequest(uri);
    const actionOnGoodResponse = (json) => {
      const hash = json.hash;
      showAlert(this, 'hash: ' + hash);
    };
    apiFetch(this, request, actionOnGoodResponse);
  }

  testLogging() {
    const uri = '/api/superAdmin/testLogging';
    const request = createStdRequest(uri);
    const actionOnGoodResponse = () => {
      showAlert(this, 'Back from call to testLogging');
    };
    apiFetch(this, request, actionOnGoodResponse);
  }

  testSendGrid() {
    const uri = '/api/superAdmin/testSendGrid';
    const request = createStdRequest(uri);
    const actionOnGoodResponse = () => {
      showAlert(this, 'Back from call to testSendGrid');
    };
    apiFetch(this, request, actionOnGoodResponse);
  }

  testEnvVars() {
    const uri = '/api/superAdmin/testEnvVars';
    const request = createStdRequest(uri);
    const actionOnGoodResponse = () => {
      showAlert(this, 'Back from call to testEnvVars');
    };
    apiFetch(this, request, actionOnGoodResponse);
  }

  patchOtherParty() {
    const uri = '/api/callRail/insertOtherParty';
    const request = createStdRequest(uri);
    const actionOnGoodResponse = () => {
      showAlert(this, 'Back from call to insertOtherParty');
    };
    apiFetch(this, request, actionOnGoodResponse);
  }

  simulateDischarge() {
    const uri = '/api/superAdmin/simulateDischarge';
    const request = createStdRequest(uri);
    const actionOnGoodResponse = () => {
      showAlert(this, 'Back from call to simulateDischarge');
    };
    apiFetch(this, request, actionOnGoodResponse);
  }

  kludgeBirthdates() {
    const uri = '/api/superAdmin/kludgeBirthdates';
    const request = createStdRequest(uri);
    const actionOnGoodResponse = () => {
      showAlert(this, 'Back from call to kludgeBirthdates');
    };
    apiFetch(this, request, actionOnGoodResponse);
  }

  kludgeClientPhoneNumbers() {
    const uri = '/api/superAdmin/kludgeClientPhoneNumbers';
    const request = createStdRequest(uri);
    const actionOnGoodResponse = () => {
      showAlert(this, 'Back from call to kludgeClientPhoneNumbers');
    };
    apiFetch(this, request, actionOnGoodResponse);
  }

  addEdConsultMenuItems() {
    const uri = '/api/superAdmin/addEdConsultMenuItems';
    const request = createStdRequest(uri);
    const actionOnGoodResponse = () => {
      showAlert(this, 'Back from call to addEdConsultMenuItems');
    };
    apiFetch(this, request, actionOnGoodResponse);
  }

  testCrmUserRolesTable() {
    const uri = '/api/superAdmin/testCrmUserRolesTable';
    const request = createStdRequest(uri);
    const actionOnGoodResponse = (json) => {
      json.both.sort();
      json.justAsp.sort();
      json.justCrm.sort();
      showAlert(this, JSON.stringify(json));
    };
    apiFetch(this, request, actionOnGoodResponse);
  }

  patchOwnerships() {
    const uri = '/api/superAdmin/patchOwnerships';
    const request = createStdRequest(uri);
    const actionOnGoodResponse = () => {
      showAlert(this, 'Back from call to patchOwnerships');
    };
    apiFetch(this, request, actionOnGoodResponse);
  }

  patchDateTimes() {
    const uri = '/api/superAdmin/patchDateTimes';
    const request = createStdRequest(uri);
    const actionOnGoodResponse = () => {
      reportTime('patchDateTimes', beforeCall);
      showAlert(this, 'Back from call to patchDateTimes');
    };
    const beforeCall = DateTime.local();
    apiFetch(this, request, actionOnGoodResponse);
  }

  performRandomExperiment() {
    // this.experimentWithTime();
    this.copyNoteOwnerships();
  }

  copyNoteOwnerships() {
    const uri = '/api/superAdmin/copyNoteOwnerships';
    const request = createStdRequest(uri, 'GET');
    const actionOnGoodResponse = (json) => {
      showAlert(this, json.message);
    };
    apiFetch(this, request, actionOnGoodResponse);
  }

  experimentWithTime() {
    // The idea here is to have one button that can be repurposed to do various things.
    // We'll do that by changing the uri to invoke whatever we want.

    // const uri = '/api/superAdmin/patchOwnerships';

    const dtLocal = DateTime.local();
    const dtUtc = DateTime.local();
    const dtUtc2Local = DateTime.utc().toLocal();
    const dtLocal2Utc = DateTime.local().toUTC();
    console.log(`dt.loc -> ISO: ${dtLocal.toISO()}`);
    console.log(`dt.utc -> ISO: ${dtUtc.toISO()}`);
    console.log(`dt.u_l -> ISO: ${dtUtc2Local.toISO()}`);
    console.log(`dt.l_u -> ISO: ${dtLocal2Utc.toISO()}`);
    console.log('');

    const apiStruct = {
      utc8601: dtUtc.toISO(),
      loc8601: dtLocal.toISO(),
      u_l8601: dtUtc2Local.toISO(),
      l_u8601: dtLocal2Utc.toISO(),
    };
    const uri = '/api/superAdmin/testDates';
    const request = createStdRequest(uri, 'POST', apiStruct);
    const actionOnGoodResponse = (json) => {
      if (json.message) {
        showAlert(this, json.message);
      } else {
        const { utcAsIso8601, localAsIso8601, u2LAsIso8601, l2UAsIso8601 } = json;
        console.log(`utcAsIso8601:    ${utcAsIso8601}`);
        console.log(`localAsIso8601:  ${localAsIso8601}`);
        console.log(`u2LAsIso8601:    ${u2LAsIso8601}`);
        console.log(`l2UAsIso8601:    ${l2UAsIso8601}`);

        const dtLocal2 = DateTime.fromISO(localAsIso8601);
        const dateString = dtLocal2.toLocaleString();
        console.log(`dateString:    ${dateString}`);
        const timeSimple = dtLocal2.toLocaleString(DateTime.TIME_SIMPLE);
        console.log(`timeSimple:    ${timeSimple}`);

        showAlert(this, 'Back from Random Experiment');
      }
    };
    apiFetch(this, request, actionOnGoodResponse);
  }

  setTimeZone01() {
    const uri = '/api/superAdmin/setTimeZones';
    const request = createStdRequest(uri);
    const actionOnGoodResponse = () => {
      showAlert(this, 'Back from call to setTimeZones01');
    };
    apiFetch(this, request, actionOnGoodResponse);
  }

  patchVobInfo() {
    const uri = '/api/superAdmin/patchVobInfo';
    const request = createStdRequest(uri);
    const actionOnGoodResponse = () => {
      showAlert(this, 'Back from call to patchVobInfo');
    };
    apiFetch(this, request, actionOnGoodResponse);
  }

  deleteDuplicateContacts() {
    const uri = '/api/superAdmin/deleteDuplicateContactFirms';
    const request = createStdRequest(uri);
    const actionOnGoodResponse = () => {
      showAlert(this, 'Back from call to deleteDuplicateContactFirms');
    };
    apiFetch(this, request, actionOnGoodResponse);
  }

  inferReferralSourceTypes() {
    const uri = '/api/superAdmin/inferReferralSourceTypes';
    const request = createStdRequest(uri);
    const actionOnGoodResponse = () => {
      showAlert(this, 'Back from call to inferReferralSourceTypes');
    };
    apiFetch(this, request, actionOnGoodResponse);
  }

  inferLeadSourceTypes() {
    const uri = '/api/superAdmin/inferLeadSourceTypes';
    const request = createStdRequest(uri);
    const actionOnGoodResponse = () => {
      showAlert(this, 'Back from call to inferLeadSourceTypes');
    };
    apiFetch(this, request, actionOnGoodResponse);
  }

  migrateDeletedReferrals() {
    const uri = '/api/superAdmin/migrateDeletedReferrals';
    const request = createStdRequest(uri);
    const actionOnGoodResponse = () => {
      showAlert(this, 'Back from call to migrateDeletedReferrals');
    };
    apiFetch(this, request, actionOnGoodResponse);
  }

  async processMissingCalls() {
    try {
      const response = await axios.request({
        responseType: 'blob',
        url: '/api/superAdmin/processMissingCalls',
        method: 'get',
        headers: {
          Accept: 'application/vnd.oasis.opendocument.spreadsheet',
        },
      });

      // when we get a response, open up an invisible link and click it
      const fileBuffer = response.data;
      const blob = new Blob([fileBuffer], { type: 'application/vnd.oasis.opendocument.spreadsheet' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'missingCallReport.ods';
      a.click();
    } catch (err) {
      console.error(err);
    }
  }

  async processCallsWithNoFirmId() {
    try {
      const response = await axios.request({
        responseType: 'blob',
        url: '/api/superAdmin/processCallsWithNoFirmId',
        method: 'get',
        headers: {
          Accept: 'application/vnd.oasis.opendocument.spreadsheet',
        },
      });

      // when we get a response, open up an invisible link and click it
      const fileBuffer = response.data;
      const blob = new Blob([fileBuffer], { type: 'application/vnd.oasis.opendocument.spreadsheet' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'callsWithNoFirmId.ods';
      a.click();
    } catch (err) {
      console.error(err);
    }
  }

  showConvertCallRailMemosModal() {
    this.setState({ shouldShowCallRailMemoConversionModal: true });
  }

  copyFirmType2F2fv() {
    const uri = '/api/superAdmin/copyFirmTypeToF2fv';
    const request = createStdRequest(uri);
    const actionOnGoodResponse = (json) => {
      alert('Copying succeded!');
    };
    apiFetch(this, request, actionOnGoodResponse);
  }

  populateF2fvEmail() {
    const uri = '/api/superAdmin/populateF2fvEmail';
    const request = createStdRequest(uri);
    const actionOnGoodResponse = (json) => {
      alert('PopulationSucceeded succeded!');
    };
    apiFetch(this, request, actionOnGoodResponse);
  }

  populateAppUserExtTable() {
    const uri = '/api/superAdmin/populateAppUserExtTable';
    const request = createStdRequest(uri);
    const actionOnGoodResponse = (json) => {
      alert('Population succeded!');
    };
    apiFetch(this, request, actionOnGoodResponse);
  }

  async convertCallRailMemos(companyName) {
    if (!companyName) {
      alert(`You need to pick an account`);
      return;
    }
    const encodedCompanyName = encodeURIComponent(companyName);
    const uri = `/api/superAdmin/convertCallRailCallMemosForCompany/${encodedCompanyName}`;
    const request = createStdRequest(uri);
    const actionOnGoodResponse = (json) => {
      const { success, message } = json;
      if (success) {
        alert(`conversion succeeded with message: ${message}`);
      } else {
        alert(`conversion failed with error message: ${message}`);
      }
      this.setState({ shouldShowCallRailMemoConversionModal: false });
    };
    apiFetch(this, request, actionOnGoodResponse);
  }

  async exportCleanRecoveryClientNotes() {
    try {
      const response = await axios.request({
        responseType: 'blob',
        url: '/api/superAdmin/getCleanRecoveryClientNotes',
        method: 'get',
        headers: {
          Accept: 'application/vnd.oasis.opendocument.spreadsheet',
        },
      });

      // when we get a response, open up an invisible link and click it
      const fileBuffer = response.data;
      const blob = new Blob([fileBuffer], { type: 'application/vnd.oasis.opendocument.spreadsheet' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'cleanRecoveryClientNotes.ods';
      a.click();
    } catch (err) {
      console.error(err);
    }
  }

  addDemos1(nDemos, nUsers) {
    const apiStruct = this.createDemos1ApiStruct(nDemos, nUsers);
    this.addDemos(apiStruct);
  }

  createDemos1ApiStruct(nDemos, nUsers) {
    return {
      firmNamePrefix: this.state.prefix,
      nDemos: nDemos,
      minUsersPerDemo: nUsers,
      maxUsersPerDemo: nUsers,
      avgVisibleFirmsPerFirm: 1,
      avgFacilitiesPerFirm: 1,
      avgPractitionersPerFirm: 1,
      avgClientsPerFirm: 1,
      avgNotesPerFirm: 1,
      avgLeadsPerFirm: 1,
      avgActivitiesPerFirm: 1,
      avgTasksPerFirm: 1,
    };
  }

  addDemos2(nDemos, nUsers, nOthers) {
    const apiStruct = this.createDemos2ApiStruct(nDemos, nUsers, nOthers);
    this.addDemos(apiStruct);
  }

  createDemos2ApiStruct(nDemos, nUsers, nOthers) {
    return {
      firmNamePrefix: this.state.prefix,
      nDemos: nDemos,
      minUsersPerDemo: nUsers,
      maxUsersPerDemo: nUsers,
      avgVisibleFirmsPerFirm: nOthers,
      avgFacilitiesPerFirm: 2,
      avgPractitionersPerFirm: nOthers,
      avgClientsPerFirm: nOthers,
      avgNotesPerFirm: nOthers,
      avgLeadsPerFirm: nOthers,
      avgActivitiesPerFirm: nOthers,
      avgTasksPerFirm: nOthers,
      randomDistribution: this.state.randomDistribution,
    };
  }

  scaleItemPerFirm(unscaledCount, multiplier) {
    return Math.max(Math.floor(unscaledCount * multiplier), 1);
  }

  addDemoAsFullAsAccounts(multiplier) {
    const maxReferralFirmsSeenInTheWild = 250;
    const maxPractitionersSeenInTheWild = 150;
    const maxClientsSeenInTheWild = 500;
    const maxNotesSeenInTheWild = 200;
    const maxLeadsSeenInTheWild = 200;
    const maxActivitiesSeenInTheWild = 600;
    const maxTasksSeenInTheWild = 250;

    const nReferralFirms = this.scaleItemPerFirm(maxReferralFirmsSeenInTheWild, multiplier);
    const avgFacilitiesPerFirm = 2; // just make this a constant
    const avgPractitionersPerFirm = this.scaleItemPerFirm(maxPractitionersSeenInTheWild, multiplier);
    const avgClientsPerFirm = this.scaleItemPerFirm(maxClientsSeenInTheWild, multiplier);
    const avgNotesPerFirm = this.scaleItemPerFirm(maxNotesSeenInTheWild, multiplier);
    const avgLeadsPerFirm = this.scaleItemPerFirm(maxLeadsSeenInTheWild, multiplier);
    const avgActivitiesPerFirm = this.scaleItemPerFirm(maxActivitiesSeenInTheWild, multiplier);
    const avgTasksPerFirm = this.scaleItemPerFirm(maxTasksSeenInTheWild, multiplier);

    const apiStruct = {
      firmNamePrefix: this.state.prefix,
      nDemos: 1,
      minUsersPerDemo: 3,
      maxUsersPerDemo: 3,
      avgVisibleFirmsPerFirm: nReferralFirms,
      minVisibleFirmsPerFirm: nReferralFirms,
      maxVisibleFirmsPerFirm: nReferralFirms,
      avgFacilitiesPerFirm,
      avgPractitionersPerFirm,
      avgClientsPerFirm,
      avgNotesPerFirm,
      avgLeadsPerFirm,
      avgActivitiesPerFirm,
      avgTasksPerFirm,
      randomDistribution: this.state.randomDistribution,
    };
    this.addDemos(apiStruct);
  }

  addDemos(apiStruct) {
    const uri = '/api/demo/seedRandom';
    const request = createStdRequest(uri, 'POST', apiStruct);
    const startTime = new Date().getTime();
    const actionOnGoodResponse = (json) => {
      const duration = new Date().getTime() - startTime;
      const seconds = Math.round(duration / 1000);
      const minutes = Math.round(duration / (1000 * 60));
      const hours = Math.round((duration * 100) / (1000 * 60 * 60)) / 100;
      showAlert(this, `Done in ${duration} ms (${seconds} seconds) (${minutes} minutes) (${hours} hours)`);
    };
    apiFetch(this, request, actionOnGoodResponse);
  }

  deleteDemos() {
    this.hardNDeleted = 0;
    this.deletionStartTime = new Date().getTime();
    this.setState({ nDeleted: 0, continueDeleting: true });
    const uri = '/api/demo/idsAndFirmNames';
    const request = createStdRequest(uri);
    const actionOnGoodResponse = (json) => {
      const demoIdsAndFirmNames = json;
      const matchingPairs = demoIdsAndFirmNames.filter((diafn) => diafn.firmName.startsWith(this.state.prefix));
      const demoIds = matchingPairs.map((pair) => pair.demoId);
      this.setState({ nMatchingDemos: demoIds.length });
      this.deleteDemosWithIds(demoIds);
    };
    apiFetch(this, request, actionOnGoodResponse);
  }

  deletionStartTime = 0;
  hardNDeleted = 0;

  deleteDemosWithIds(demoIds) {
    if (demoIds.length === 0) {
      const duration = new Date().getTime() - this.deletionStartTime;
      const seconds = Math.round(duration / 1000);
      const minutes = Math.round(duration / (1000 * 60));
      const hours = Math.round((duration * 100) / (1000 * 60 * 60)) / 100;
      showAlert(this, `Done in ${duration} ms (${seconds} seconds) (${minutes} minutes) (${hours} hours)`);
    } else {
      const headId = demoIds[0];
      const tailIds = demoIds.slice(1);
      this.deleteDemoWithId(headId, tailIds);
    }
  }

  deleteDemoWithId(demoId, remainingIds) {
    const uri = '/api/demo/' + demoId;
    const request = createStdRequest(uri, 'DELETE');
    const actionOnGoodResponse = (json) => {
      this.hardNDeleted += 1;
      this.setState({ nDeleted: this.hardNDeleted });
      this.deleteDemosWithIds(remainingIds);
    };
    apiFetch(this, request, actionOnGoodResponse);
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to={this.state.redirect} push />;
    }
    const { classes, userInfo } = this.props;
    const { prefName, lastName } = userInfo;
    const { lostDropdownItems, firmsWithoutSalesLines } = this.state;
    const namesOfFirmWithoutSalesLines = firmsWithoutSalesLines.map((firm) => firm.name);
    const idsOfFirmWithoutSalesLines = firmsWithoutSalesLines.map((firm) => firm.firmId);
    return (
      <div>
        <AlertModal show={this.state.shouldShowAlertModal} renderer={this} text={this.state.alertModalText} />

        <CallRailMemoConversionModal
          show={this.state.shouldShowCallRailMemoConversionModal}
          onSubmit={(companyName) => this.convertCallRailMemos(companyName)}
          onClose={() => this.setState({ shouldShowCallRailMemoConversionModal: false })}
        />

        <div className={classes.root}>
          <h3>
            This is the default home page for {prefName} {lastName}
          </h3>
          <div className="pageDescrip">
            Because {prefName} is a SuperAdmin, this page should provide ways to
            <ul>
              <li>authorize other SuperAdmins</li>
              <li>create new accounts for Alleva Reps</li>
              <li>create new Provider accounts</li>
              <li>etc.</li>
            </ul>
          </div>
          <table style={{ paddingLeft: '100px' }}>
            <tbody>
              <tr>
                <td>
                  <Button onClick={() => this.handleViewDemosClick()}>View All Demos</Button>
                </td>
                <td>
                  <Button onClick={() => this.handleLaunchDemoClick()}>Launch new Demo</Button>
                </td>
              </tr>
              <tr>
                <td>
                  <Button onClick={() => this.handleViewAllAccountsClick()}>View All Accounts</Button>
                </td>
                <td>
                  <Button onClick={() => this.handleRegisterProviderClick()}>Register new Account</Button>
                </td>
              </tr>
            </tbody>
          </table>
          <table style={{ paddingLeft: '100px' }}>
            <tbody>
              <tr>
                <td>
                  <Button onClick={() => this.handleUploadSpreadsheetClick()}>Upload Spreadsheet</Button>
                </td>
                <td>
                  <Button onClick={() => this.handleConfigEmrSyncClick()}>Configure EMR Sync</Button>
                </td>
              </tr>
            </tbody>
          </table>
          <div>
            <Button onClick={() => this.handleDownloadFirmClick()}>Download Firm Info</Button>
          </div>
          <div>
            <Button onClick={() => this.handleShowSalesLineUIClick()}>Add Account Sales Line Phone Numbers</Button>
          </div>
          <Showable show={this.state.shouldShowSalesLineUI}>
            <div className={classes.salesLineUiDiv}>
              <div>
                <KSelect
                  fullWidth
                  label="Account"
                  liveOptions={namesOfFirmWithoutSalesLines}
                  liveValues={idsOfFirmWithoutSalesLines}
                  value={this.state.salesLineTargetFirmId}
                  onChange={(event) => this.handleSalesLineTargetFirmChange(event.target.value)}
                />
              </div>
              <div>
                <CrmTextField
                  required
                  label="Sales Phone Line"
                  value={this.state.phoneForAccount}
                  onChange={(event) => this.setState({ phoneForAccount: event.target.value })}
                />
              </div>
              <div>
                <Button className={classes.setSalesLineButton} onClick={() => this.handleSetSalesLineClick()}>
                  Set Number
                </Button>
                <Button onClick={() => this.setState({ shouldShowSalesLineUI: false })}>Close</Button>
              </div>
            </div>
          </Showable>
          <div>
            {this.showInitDropdownsButton && (
              <div>
                <Button onClick={() => this.initCustomizableDropdowns()}>Init Dropdowns</Button>
                <br />
              </div>
            )}
            {this.showRegularizePhoneNumbersButton && (
              <div>
                <Button onClick={() => this.regularizePhoneNumbers()}>Regularize Phone Numbers</Button>
                <br />
              </div>
            )}
            {this.showStandardizePhoneNumbersButton && (
              <div>
                <Button onClick={() => this.standardizePhoneNumbers()}>
                  Standardize Phone Numbers: (AAA) EEE-NNNN
                </Button>
                <br />
              </div>
            )}
            {this.showPromoteNonesButton && (
              <div>
                <Button onClick={() => this.convertNonesToProspects()}>Convert 'None's to 'Prospect's</Button>
                <br />
              </div>
            )}
            {this.showConvertToSingleFacilityAddressButton && (
              <div>
                <Button onClick={() => this.convertToSingleFacilityAddressScheme()}>
                  Convert to Single Facility Address Scheme
                </Button>
                <br />
              </div>
            )}
            {this.showPopulateFirmTypeNameButton && (
              <div>
                <Button onClick={() => this.populateFirmTypeName()}>Populate Firm_Type_Name field</Button>
                <br />
              </div>
            )}
            {this.showPartitionReferralSourceTypeDropdownItemsButton && (
              <div>
                <Button onClick={() => this.partitionReferralSourceTypeDropdownItems()}>
                  Partition Referral Source Type Dropdown Items
                </Button>
                <br />
              </div>
            )}
            {this.showCopyFirmTypeNameFieldButton && (
              <div>
                <Button onClick={() => this.copyFirmTypeNameField()}>Copy Firm_Type_Name Field</Button>
                <br />
              </div>
            )}
            {this.showPopulateApiKeyFirmIdFieldsButton && (
              <div>
                <Button onClick={() => this.populateApiKeyFirmIdFields()}>Populate Api Key Firm Id Fields</Button>
                <br />
              </div>
            )}
            {this.showPopulateReimbursementDropdownButton && (
              <div>
                <Button onClick={() => this.populateReimbursementDropdown()}>Re-Populate Reimbursement Dropdown</Button>
                <br />
              </div>
            )}
            {this.showPopulateDocTypeDropdownButton && (
              <div>
                <Button onClick={() => this.populateDocTypeDropdown()}>Populate DocumentType Dropdown</Button>
                <br />
              </div>
            )}
            {this.showDeleteDocumentsButton && (
              <div>
                <Button onClick={() => this.deleteAllDocuments()}>Delete Documents</Button>
                <br />
              </div>
            )}
            {this.showExtendSexButton && (
              <div>
                <Button onClick={() => this.fillInExtendedSex()}>Extend Representation of Gender</Button>
                <br />
              </div>
            )}
            {this.showCopyToSexButton && (
              <div>
                <Button onClick={() => this.copyToSex()}>Copy Representation of Gender</Button>
                <br />
              </div>
            )}
            {this.showShowLostDropdownItemsButton && (
              <div>
                <Button onClick={() => this.showLostDropdownItems()}>Show Lost Dropdown Items</Button>
                <br />
                {this.state.shouldShowLostDropdownItems && (
                  <table>
                    <tbody>
                      <tr>
                        <th>Dropown</th>
                        <th>Items</th>
                      </tr>
                      {lostDropdownItems.items.map((singleItems, index) => (
                        <tr key={index}>
                          <td>{singleItems.ddName}</td>
                          {singleItems.lostItems.map((lostItem, i) => (
                            <td key={i}>{lostItem}</td>
                          ))}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}
              </div>
            )}
            {this.showRestoreLostDropdownItemsButton && (
              <div>
                <Button onClick={() => this.restoreLostDropdownItems()}>Restore Lost Dropdown Items</Button>
                <br />
              </div>
            )}
            {this.showRepairNullPhoneRolesButton && (
              <div>
                <Button onClick={() => this.repairNullPhoneRoles()}>Repair NULL Phone Roles</Button>
                <br />
              </div>
            )}
            {this.showTrimDbStringsButton && (
              <div>
                <Button onClick={() => this.trimDbStrings()}>Detect/Trim DB Strings</Button>
                <span>
                  <input
                    type="checkbox"
                    checked={this.state.justDetectTrimmableStrings}
                    onChange={(event) => this.handleDetectTrimmableStringsCheckboxChange(event)}
                  />
                  Just Detect
                </span>
                <br />
              </div>
            )}
            {this.showRenameAutoSeedsButton && (
              <div>
                <Button onClick={() => this.renameAutoSeeds()}>Rename AutoSeeds</Button> From
                <input
                  value={this.state.oldAutoSeedPrefix}
                  onChange={(event) => this.setState({ oldAutoSeedPrefix: event.target.value })}
                />{' '}
                To
                <input
                  value={this.state.newAutoSeedPrefix}
                  onChange={(event) => this.setState({ newAutoSeedPrefix: event.target.value })}
                />
                <br />
              </div>
            )}
            {this.showEnableDefaultDropdownItemProtectionButton && (
              <div>
                <Button onClick={() => this.enableDefaultDropdownItemProtection()}>
                  Enable Default Dropdown Item Protection
                </Button>
              </div>
            )}
            {this.showWebhookValidationButton && (
              <div>
                <Button onClick={() => this.testWebookValidation()}>Test Webhook Validation</Button>
              </div>
            )}
            {this.showLogTestButton && (
              <div>
                <Button onClick={() => this.testLogging()}>Test Logging</Button>
              </div>
            )}
            {this.showSendGridTestButton && (
              <div>
                <Button onClick={() => this.testSendGrid()}>Test SendGrid</Button>
              </div>
            )}
            {this.showTestEnvVarsButton && (
              <div>
                <Button onClick={() => this.testEnvVars()}>Test EnvVars</Button>
              </div>
            )}
            {this.showPatchOtherPartyButton && (
              <div>
                <Button onClick={() => this.patchOtherParty()}>Patch OtherParty in Calls</Button>
              </div>
            )}
            {this.showSimulateDischargeButton && (
              <div>
                <Button onClick={() => this.simulateDischarge()}>Simulate Discharge</Button>
              </div>
            )}
            {this.showKludgeBirthdatesButton && (
              <div>
                <Button onClick={() => this.kludgeBirthdates()}>Kludge Birthdates</Button>
              </div>
            )}
            {this.showKludgeClientPhoneNumbersButton && (
              <div>
                <Button onClick={() => this.kludgeClientPhoneNumbers()}>Kludge Client Phone Numbers</Button>
              </div>
            )}
            {this.showAddEdConsultDropdownItemButton && (
              <div>
                <Button onClick={() => this.addEdConsultMenuItems()}>Add Ed Consult Menu Items</Button>
              </div>
            )}
            {this.showTestUserRolesTable && (
              <div>
                <Button onClick={() => this.testCrmUserRolesTable()}>Test Crm_User_Roles Table</Button>
              </div>
            )}
            {this.showPatchOwnershipsButton && (
              <div>
                <Button onClick={() => this.patchOwnerships()}>Patch Ownerships</Button>
              </div>
            )}
            {this.showPatchDateTimesButton && (
              <div>
                <Button onClick={() => this.patchDateTimes()}>Patch DateTimes</Button>
              </div>
            )}
            {prefName === 'Kim' && this.showRandomExperimentButton && (
              <div>
                <Button onClick={() => this.performRandomExperiment()}>Perform Random Experiment</Button>
              </div>
            )}
            {prefName === 'Kim' && this.showSetTimeZoneButton && (
              <div>
                <Button onClick={() => this.setTimeZone01()}>Set Time Zone</Button>
              </div>
            )}
            {prefName === 'Kim' && this.showPatchVobInfoButton && (
              <div>
                <Button onClick={() => this.patchVobInfo()}>Patch VOB Info</Button>
              </div>
            )}
            {prefName === 'Kim' && this.showDeleteDupsButton && (
              <div>
                <Button onClick={() => this.deleteDuplicateContacts()}>Delete Duplicate Contacts</Button>
              </div>
            )}
            {prefName === 'Kim' && this.showInferReferralSourceTypesButton && (
              <div>
                <Button onClick={() => this.inferReferralSourceTypes()}>Infer Referral Source Types</Button>
              </div>
            )}
            {prefName === 'Kim' && this.showInferLeadSourceTypesButton && (
              <div>
                <Button onClick={() => this.inferLeadSourceTypes()}>Infer Lead Source Types</Button>
              </div>
            )}
            {prefName === 'Kim' && this.showMigrateDeletedReferralsButton && (
              <div>
                <Button onClick={() => this.migrateDeletedReferrals()}>Migrate Deleted Referrals</Button>
              </div>
            )}
            {prefName === 'Kim' && this.showProcessMissingCallsButton && (
              <div>
                <Button onClick={() => this.processMissingCalls()}>Process Missing Calls</Button>
              </div>
            )}
            {prefName === 'Kim' && this.showProcessCallsWithNoFirmIdButton && (
              <div>
                <Button onClick={() => this.processCallsWithNoFirmId()}>Process Calls With No Firm Id</Button>
              </div>
            )}
            {prefName === 'Kim' && this.showConvertCallRailMemosButton && (
              <div>
                <Button onClick={() => this.showConvertCallRailMemosModal()}>Convert CallRail Memos</Button>
              </div>
            )}
            {prefName === 'Kim' && this.showCopyFirmTypeButton && (
              <div>
                <Button onClick={() => this.copyFirmType2F2fv()}>Copy Firm Type to F2FV</Button>
              </div>
            )}
            {prefName === 'Kim' && this.showPopulateF2fvEmailButton && (
              <div>
                <Button onClick={() => this.populateF2fvEmail()}>Populate F2FV.Email</Button>
              </div>
            )}
            {prefName === 'Kim' && this.showPopulateAppUserExtTableButton && (
              <div>
                <Button onClick={() => this.populateAppUserExtTable()}>Populate AppUserExt Table</Button>
              </div>
            )}
            {prefName === 'Kim' && (
              <div style={{ background: 'white', border: '1px solid black' }}>
                Auto-seeded Demos&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <input
                  type="checkbox"
                  value={this.state.randomDistribution}
                  onChange={(event) => this.setState({ randomDistribution: event.target.checked })}
                />
                &nbsp;random distribution
                <br />
                <table>
                  <tbody>
                    <tr>
                      <td>
                        <button onClick={() => this.addDemos2(1, 1, 0)}>Add 1 very bare Demo</button>
                      </td>
                      <td>
                        <button onClick={() => this.addDemos1(1, 1)}>Add 1 Demo w/ 1 User</button>
                      </td>
                      <td>
                        <button onClick={() => this.addDemos2(2, 2, 2)}>
                          Add 2 Demos w/ 2 of everything else each
                        </button>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <button onClick={() => this.addDemos2(1, 2, 10)}>
                          Add 1 Demo w/ 10 of everything else each
                        </button>
                      </td>
                      <td>
                        <button onClick={() => this.addDemos2(10, 2, 10)}>
                          Add 10 Demos w/ 10 of everything else each
                        </button>
                      </td>
                      <td>
                        <button onClick={() => this.addDemos2(100, 2, 10)}>
                          Add 100 Demos w/ 10 of everything else each
                        </button>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <button onClick={() => this.addDemos2(1, 2, 100)}>
                          Add 1 Demo w/ 100 of everything else each
                        </button>
                      </td>
                      <td>
                        <button onClick={() => this.addDemos2(10, 2, 100)}>
                          Add 10 Demos w/ 100 of everything else each
                        </button>
                      </td>
                      <td>
                        <button onClick={() => this.addDemos2(50, 2, 100)}>
                          Add 50 Demos w/ 100 of everything else each
                        </button>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <button onClick={() => this.addDemoAsFullAsAccounts(0.02)}>
                          Add Demo 2% as full as big Accounts
                        </button>
                      </td>
                      <td>
                        <button onClick={() => this.addDemoAsFullAsAccounts(0.1)}>
                          Add Demo 10% as full as big Accounts
                        </button>
                      </td>
                      <td>
                        <button onClick={() => this.addDemoAsFullAsAccounts(1)}>
                          Add Demo as full as big Accounts
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div>
                  <button onClick={() => this.deleteDemos()}>Delete Demos</button>
                  Prefix:{' '}
                  <input
                    value={this.state.prefix}
                    onChange={(event) => this.setState({ prefix: event.target.value.trim() })}
                  />
                  Deleted: <span>{` ${this.state.nDeleted} of ${this.state.nMatchingDemos} `}</span>
                  <button onClick={() => this.setState({ continueDeleting: false })}>Stop Deleting</button>
                </div>
              </div>
            )}
          </div>
          <div>
            <br />
            Note: You are viewing version {version} of this application.
          </div>
        </div>
      </div>
    );
  }
}

const CallRailMemoConversionModal = ({ show, onSubmit, onClose }) => {
  const [chosenName, setChosenName] = useState('');
  const [namesToMatch, setNamesToMatch] = useState(null);

  if (namesToMatch === null) {
    // Make API call to determine which firms have unhandled CallRail WebHook payloads
    const uri = '/api/superAdmin/companyNamesWithUnhandledCallRailWebHookPayloads';
    const request = createStdRequest(uri);
    const actionOnGoodResponse = (json) => {
      setNamesToMatch(json);
    };
    apiFetch(null, request, actionOnGoodResponse);
  }

  return (
    <Modal
      open={show}
      title={'Convert CallRail Memos for some Account'}
      okButtonLabel="Submit"
      cancelButtonLabel="Cancel"
      onOk={() => onSubmit(chosenName)}
      onCancel={onClose}
    >
      <KSelect
        label="Name of Account to convert"
        fullWidth={true}
        disabledOption="Choose A Name"
        liveOptions={namesToMatch || []}
        value={chosenName}
        onChange={(event) => setChosenName(event.target.value)}
      />
    </Modal>
  );
};

const mapStateToProps = (state) => ({ userInfo: state.userInfo });

const actionProducers = { setApiResponseInfo };

export default connect(mapStateToProps, actionProducers)(withStyles(homeStyles)(SuperAdminHome));
